<template>
    <div class="container">
        <h2 class="profile-page-title">
            Ваш FromRefID
        </h2>

        <div class="row">
            <div class="col-12 pt-6 text-center"
                 style="font-family: Intro Bold; font-size: 40px;">
                <span v-if="user.from_ref_id">{{ user.from_ref_id }}</span>
                <span v-else>&mdash;</span>
            </div>
            <div class="col-12 pb-8 text-center" style="font-size: 30px;">
                <span v-if="user.from_ref_id_created">{{ user.from_ref_id_created | formatDate }}</span>
            </div>
        </div>

    </div>
</template>

<script>

    import userApi from "../../../data/UserApi";
    import moment from 'moment';

    export default {
        name: 'FromRefID',

        data() {
            return {
                user: {
                    from_ref_id: null,
                    from_ref_id_created: null,
                },
            }
        },

        mounted() {
            moment.locale(this.$i18n.locale)
            userApi.fetchProfile()
                .then(response => {
                    this.user = response;
                });
        },

        filters: {
            formatDate: function (value) {
                return moment.unix(value).format('DD.MM.YYYY HH:mm:ss')
            }
        },

        methods: {},

    }
</script>

<style>

</style>
